
import { Component, Vue, Prop} from 'vue-property-decorator';
import * as SurveyVue from "survey-vue";
import surveyJson from "./forms/legal-duty-another-person-fs.json";
import * as surveyEnv from "@/components/survey/survey-glossary";

import { legalDutyAnotherPersonFSDataInfoType } from '@/types/Application/FinancialStatement';

@Component
export default class LegalDutyAnotherPersonFSSurvey extends Vue {
    
    @Prop({required: true})
    editRowProp!: Object;    
    
    anotherPersonExpense = {} as legalDutyAnotherPersonFSDataInfoType;

    survey = new SurveyVue.Model(surveyJson);
    currentStep =0;
    currentPage =0;

    beforeCreate() {
        const Survey = SurveyVue;
        surveyEnv.setCss(Survey);       
    }

    mounted(){
        this.initializeSurvey();
        this.addSurveyListener();
        this.reloadPageInformation();
    }

    public initializeSurvey(){
        this.survey = new SurveyVue.Model(surveyJson);
        this.survey.commentPrefix = "Comment";
        this.survey.showQuestionNumbers = "off";
        this.survey.showNavigationButtons = false;
        surveyEnv.setGlossaryMarkdown(this.survey);
    }
    
    public addSurveyListener(){

        this.survey.onValueChanged.add((sender, options) => {
            
            if(options.name == 'monthlyPayment')
                this.survey.setValue('yearlyPayment',options.value * 12);
            else if(options.name == 'yearlyPayment')
                this.survey.setValue('monthlyPayment',options.value/12);
                              
        })

        this.survey.onComplete.add((sender, options) => {
            this.populateChildModel(sender.data);
            let id = sender.getVariable("id");
            if (id === null || id === undefined) {
                this.$emit("surveyData", this.anotherPersonExpense);
            } else {
                this.$emit("editedData", { ...this.anotherPersonExpense, id });
                id = null;
            }
        });
    }
    
    public reloadPageInformation() {
        if (this.editRowProp != null) {
            this.populateFormWithPreExistingValues(this.editRowProp, this.survey);
        }
        
        let progress = 50;
        if(Object.keys(this.survey.data).length)
            progress = this.survey.isCurrentPageHasErrors? 50 : 100;
            
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        this.$store.commit("Application/setPageProgress", { currentStep: this.currentStep, currentPage:this.currentPage, progress:progress })      
    }
  
    public goBack() {
        this.$emit("showTable", true);
    }
    
    public saveChildExpense() {        
        this.survey.completeLastPage();
    }

    public populateChildModel(anotherPersonExpenseData) {
        if(anotherPersonExpenseData){
            this.anotherPersonExpense.antherPersonFullName = anotherPersonExpenseData.antherPersonFullName;       
            this.anotherPersonExpense.monthlyPayment = anotherPersonExpenseData.monthlyPayment;
            this.anotherPersonExpense.yearlyPayment = anotherPersonExpenseData.yearlyPayment;
        }
    }

    public populateFormWithPreExistingValues(editRowProp, survey) {
        
        survey.setValue("antherPersonFullName", editRowProp.antherPersonFullName);
        survey.setValue("debtReason", editRowProp.monthlyPayment);
        survey.setValue("yearlyPayment", editRowProp.yearlyPayment);
        survey.setVariable("id", editRowProp.id);
    }

    beforeDestroy() {
        const progress = this.survey.isCurrentPageHasErrors? 50 : 100;
        this.$store.commit("Application/setPageProgress", { currentStep: this.currentStep, currentPage:this.currentPage, progress:progress })
    }
}
